export const templates = [
  {
    id: 'restaurant',
    name: 'Savoria',
    industry: 'Restaurant',
    price: '$850',
    tier: 'premium',
    status: 'live',
    description: 'Savoria is a four-page Provençal trattoria site (Maison / La Carte / La Cuisine / Réserver). Handwritten chalkboard hero with this-week’s specials (NOT a photo hero), market-ledger of 14 named producers, course-by-course printed menu with origin notes & wine pairings, long-form chef essay, and a parchment reservation form with Léa’s confirmation note. Cream + olive + plum-burgundy palette.',
    sections: ['Handwritten Chalkboard Hero', 'Market Producer Ledger (14)', 'Chef Pull-quote', 'Course-by-course Printed Menu', 'Wine Pairing Strip', 'Long-form Chef Essay', 'Parchment Reservation Form'],
    tech: ['React', 'Framer Motion', 'Tailwind CSS', 'Multi-page'],
    color: '#6B2D4A',
    thumb: '/screenshots/restaurant.jpg',
  },
  {
    id: 'dentist',
    name: 'SmileCare',
    industry: 'Dentist / Clinic',
    price: '$850',
    tier: 'premium',
    status: 'live',
    description: 'SmileCare is a four-page Marylebone dental practice (Practice / Treatments / Doctors / Appointment). Patient-record card hero with FDI tooth-chart visualization (NOT a generic photo hero), filterable treatment ledger with codes & durations, three doctors as clinical bio cards with credentials, and a clean clinical appointment form with insurance dropdown. Clinical white + cyan + warm coral.',
    sections: ['Patient-record Card Hero with Tooth Chart', 'Three Practice Principles', 'Filterable Treatment Ledger', 'Three Clinical Doctor Cards', 'Insurance-aware Booking Form'],
    tech: ['React', 'Framer Motion', 'Tailwind CSS', 'Multi-page'],
    color: '#1B7A8C',
    thumb: '/screenshots/dentist.jpg',
  },
  {
    id: 'realestate',
    name: 'Maison Luxe',
    industry: 'Real Estate / Luxury Brokerage',
    price: '$900',
    tier: 'premium',
    status: 'live',
    description: 'Maison Luxe is a four-page Hamptons-Aspen-Côte d’Azur trophy brokerage (Office / Inventory / Estate File / Private Viewing). Filofax-style index-card hero with property dossier reveal (NOT a parallax photo hero), 11-listing inventory ledger with reference codes & comp data, two estate "wall plates" with floorplan thumbnails, and a discreet viewing-request letter form. Bone-paper + ink-blue + brass palette.',
    sections: ['Filofax Index-card Hero with Dossier Reveal', 'Inventory Ledger (11 listings) with Comps', 'Estate Wall Plates with Floorplans', 'Acquisitions Side-bar', 'Notable Closings Marquee', 'Private Viewing Letter Form'],
    tech: ['React', 'Framer Motion', 'Tailwind CSS', 'Multi-page'],
    color: '#1F3A5F',
    thumb: '/screenshots/realestate.jpg',
  },
  {
    id: 'lawfirm',
    name: 'Sterling & Hayes',
    industry: 'Law Firm',
    price: '$900',
    tier: 'premium',
    status: 'live',
    description: 'Sterling & Hayes is a four-page Lincoln’s Inn solicitors site (Chambers / Practice Areas / Counsel / Confidential). Case-file dossier hero with "CASE FILE" stamp & folio index card (NOT a marble-pillar photo), four numbered practice chapters with lead counsel, redacted "selected matters" ledger, full counsel roll table, and a privileged-letter inquiry form to the senior clerk. Oxblood + parchment + brass palette.',
    sections: ['Dossier Hero with CASE FILE Stamp', 'Folio Index Card', 'Selected Matters Ledger (Redacted)', 'Pull-quote', 'Four Numbered Practice Chapters', 'Counsel Roll Table', 'Privileged Letter of Inquiry'],
    tech: ['React', 'Framer Motion', 'Tailwind CSS', 'Multi-page'],
    color: '#5C1F1A',
    thumb: '/screenshots/lawfirm.jpg',
  },
  {
    id: 'fitness',
    name: 'IronForge',
    industry: 'Fitness / Gym',
    price: '$850',
    tier: 'premium',
    status: 'live',
    description: 'IronForge is a four-page TriBeCa strength gym (The Floor / Programs / Coaches / Free Trial). Workout-log scoreboard hero with live WOD schedule (NOT a sweaty hero photo), PR board with this-week’s lifts on the chalk, four programs as spec-sheet rows with avg KPI, three coaches as trading-cards with credentials, and a no-fluff trial-session booking form. Blacktop + signal yellow palette.',
    sections: ['Live WOD Scoreboard Hero', 'PR Board · Names on the Chalk', 'Stats Strip', 'Programs Spec Sheet (4 tracks)', 'Three Coach Trading Cards', 'Free Trial Session Booking'],
    tech: ['React', 'Framer Motion', 'Tailwind CSS', 'Multi-page'],
    color: '#F2C500',
    thumb: '/screenshots/fitness.jpg',
  },
  {
    id: 'beauty',
    name: 'Bloom',
    industry: 'Beauty Salon / Maison',
    price: '$850',
    tier: 'premium',
    status: 'live',
    description: 'Bloom is a four-page Le Marais boudoir-magazine maison (Salon / Soins / Stylistes / Booking). Editorial centered Vogue-spread hero with full-bleed model portrait (NOT a generic salon photo grid), asymmetric magazine product mosaic, courtyard-atmosphere band, codified service-ledger filterable by category, three-up styliste plates with credits, and a parchment booking form. Powder-rose + plum + soft-cream palette.',
    sections: ['Vogue-spread Editorial Hero', 'Asymmetric Product Mosaic', 'Courtyard Atmosphere Band', 'Filterable Soin Ledger', 'Three Stylist Plates', 'Parchment Booking Form'],
    tech: ['React', 'Framer Motion', 'Tailwind CSS', 'Multi-page'],
    color: '#A8567A',
    thumb: '/screenshots/beauty.jpg',
  },
  {
    id: 'saas',
    name: 'Mercurial',
    industry: 'SaaS / Developer Platform',
    price: '$900',
    tier: 'premium',
    status: 'live',
    description: 'Mercurial is a four-page live-ops developer platform (Console / Modules / Status / Pricing). Terminal-driven hero with blinking-cursor command line and live regional status pills (NOT a gradient hero), four-module spec ledger with API endpoints & rate limits, public status page with 30-day uptime grid, and a scoped pricing page with calculator. Onyx + electric-cyan + signal-green mono palette.',
    sections: ['Terminal Hero with Live Cursor & Region Pills', 'Live Deploy Log Ribbon', 'Module Spec Ledger (API endpoints + RPS)', '30-day Uptime Grid · Public Status', 'Three-tier Pricing with Live Calculator', 'Audit-Trail Footer'],
    tech: ['React', 'Framer Motion', 'Tailwind CSS', 'Multi-page'],
    color: '#06D6A0',
    thumb: '/screenshots/saas.jpg',
  },
  {
    id: 'ecommerce',
    name: 'Velour Maison',
    industry: 'Ecommerce / Atelier',
    price: '$900',
    tier: 'premium',
    status: 'live',
    description: 'Velour Maison is a four-page Florence quiet-luxury atelier catalogue (Catalogue / Pieces / Atelier / Private fitting). Printed-catalogue cover with serial-numbered hero plate & tipped-in garment image (NOT a fashion-parallax hero), table-of-contents spread, eight-piece plate-by-plate magazine archive, drop-cap atelier essay, and a parchment fitting form. Forest-green + ivory + brass palette.',
    sections: ['Catalogue Cover with Tipped-in Plate', 'Printed Table of Contents', 'Four Featured Plates', 'Plate-by-Plate Archive (8 pieces)', 'Atelier Essay with Dropcap', 'Private Fitting Form'],
    tech: ['React', 'Framer Motion', 'Tailwind CSS', 'Multi-page'],
    color: '#1F3A2E',
    thumb: '/screenshots/ecommerce.jpg',
  },
  {
    id: 'personal',
    name: 'Mira Vance',
    industry: 'Personal Brand / Open-Letter Coaching',
    price: '$850',
    tier: 'premium',
    status: 'live',
    description: 'Mira Vance is a four-page editor’s-letter personal brand (Letter / Field Notes / Engagements / Correspondence). Newspaper-front-page open letter with handwritten signature & byline metadata (NOT a portrait split hero), three-column dropcap lede, Field Notes essay archive with issue numbers & reading time, calendar-strip engagements page with three booking modes, and a written correspondence application. Cream paper + ink-black + bordeaux palette.',
    sections: ['Newspaper Front-page Letter Hero with Signature', 'Three-column Dropcap Lede', 'Field Notes Essay Archive', 'Engagements Calendar Strip', 'Three Booking Modes (Coaching / Workshop / Lecture)', 'Written Correspondence Form'],
    tech: ['React', 'Framer Motion', 'Tailwind CSS', 'Multi-page'],
    color: '#7B1A1A',
    thumb: '/screenshots/personal.jpg',
  },
  {
    id: 'agency',
    name: 'Vespera & Co.',
    industry: 'Brand & Digital Studio',
    price: '$900',
    tier: 'premium',
    status: 'live',
    description: 'Vespera & Co. is a four-page Brooklyn studio folio (Studio / Work / Thinking / Project brief). Massive serial-numbered case-folio hero with N° 047 cover plate (NOT a parallax photo break), client-marquee yellow strip, three numbered case-study spreads with scope & metrics, full 24-case ledger filterable by sector, eight studio essays with reading times, and a one-paragraph project-brief form. Klein-blue + bone + signal-yellow palette.',
    sections: ['Numbered Folio Hero with Cover Plate', 'Yellow Client Marquee Strip', 'Three Case-Study Folios (sequenced)', '24-Case Ledger with Sector Filter', 'Eight Studio Essays with Issue Numbers', 'One-Page Project Brief Form'],
    tech: ['React', 'Framer Motion', 'Tailwind CSS', 'Multi-page'],
    color: '#1B2D8C',
    thumb: '/screenshots/agency.jpg',
  },
  {
    id: 'hotel',
    name: 'Aurelia',
    industry: 'Resort & Spa',
    price: '$900',
    tier: 'premium',
    status: 'live',
    description: 'Aurelia is a four-page Cap Ferrat resort hotel (Lobby / Rooms / Spa & table / Reserve). Stamped room-key card hero with the brass-edged #0317 key tilted into the frame (NOT a generic resort parallax), four-room key-card grid, full sixty-four-room ledger with photo plates, twin Bath-house and Michelin-table profiles, and a typewriter reservation request. Burgundy + cream + gilt palette.',
    sections: ['Room-Key Card Hero with Brass Edge', 'Four Key-Card Room Grid', 'Full Room Plate Ledger', 'Bath-house Plate (1923)', 'Michelin Table Plate', 'Typewriter Reservation Request'],
    tech: ['React', 'Framer Motion', 'Tailwind CSS', 'Multi-page'],
    color: '#4A1A2C',
    thumb: '/screenshots/hotel.jpg',
  },
  {
    id: 'wedding',
    name: 'Eleanor & Marcus',
    industry: 'Wedding Save-the-Date',
    price: '$850',
    tier: 'premium',
    status: 'live',
    description: 'Eleanor & Marcus is a four-page Lago di Como scrapbook wedding site (Cover / Our story / The four days / RSVP). Full-page gatefold-album hero with two tipped-in photo plates and a typographic "spine" between them (NOT a single parallax photo), four glued-in event-ticket cards for the four days, four-chapter love-story timeline, and a complete RSVP card with song requests. Blush + sage + gold palette.',
    sections: ['Gatefold-Album Hero with Spine', 'Sage Pressed-flower Strip', 'Four Event-Ticket Day Cards', 'Four-Chapter Love-Story Timeline', 'Four-Day Detailed Itinerary', 'Heirloom RSVP Card with Song Requests'],
    tech: ['React', 'Framer Motion', 'Tailwind CSS', 'Multi-page'],
    color: '#B89C5C',
    thumb: '/screenshots/wedding.jpg',
  },
  {
    id: 'photographer',
    name: 'Mira Halcyon',
    industry: 'Photographer / Issue magazine',
    price: '$900',
    tier: 'premium',
    status: 'live',
    description: 'Mira Halcyon is a four-page issue-magazine photography site (Cover / Archive / Editor’s note / Commission). Tipped-in cover plate with title block and 8-thumb flat-plan strip (NOT a parallax photo hero), 47-plate filterable archive with frame & location captions, three-column dropcap editor’s note, and three pricing-disclosed commission modes (Editorial / Wedding / Travel). Black + warm-white + bordeaux palette.',
    sections: ['Tipped-in Magazine Cover Plate', '8-Thumb Flat-plan Strip', 'Spread with Caption Block', 'Filterable Archive (47 plates)', 'Three-column Dropcap Editor Note', 'Three Pricing-disclosed Commission Modes'],
    tech: ['React', 'Framer Motion', 'Tailwind CSS', 'Multi-page'],
    color: '#A33A3A',
    thumb: '/screenshots/photographer.jpg',
  },
  {
    id: 'crypto',
    name: 'Aether Markets',
    industry: 'Institutional Digital-Asset Desk',
    price: '$900',
    tier: 'premium',
    status: 'live',
    description: 'Aether Markets is a four-page institutional crypto desk (Desk / Live tape / House thesis / Request access). Continuously animated 8-asset ticker tape strip with editorial graphite-and-amber masthead (NOT a gradient hero), live BTC price tile with funding/OI metrics, four-KPI institutional strip, three numbered desk pillars (Block / Custody / Yield), full live tape table, and a KYC pre-screen onboarding form. Graphite + amber + signal-coral palette.',
    sections: ['Continuously Animated 8-Asset Ticker', 'Editorial Masthead', 'Live BTC Tile with OI / Funding', 'Four-KPI Strip ($4.8B AUM)', 'Three Numbered Desk Pillars', 'Full Tape Table', 'House Thesis Notes', 'KYC Pre-screen Form'],
    tech: ['React', 'Framer Motion', 'Tailwind CSS', 'Multi-page'],
    color: '#F59E0B',
    thumb: '/screenshots/crypto.jpg',
  },
  {
    id: 'coffee',
    name: 'Bramble & Bean',
    industry: 'Single-origin Roastery',
    price: '$850',
    tier: 'premium',
    status: 'live',
    description: 'Bramble & Bean is a four-page Greenpoint roastery (Roastery / The menu / Single-origin / Visit). Letterpress masthead-cover hero with the day’s issue number & double-rule decorative type (NOT a chalkboard or cinematic photo, intentionally distinct from Savoria), three-column printed-menu sheet (Espresso / Pour-over / Bakery), full menu page, four-lot single-origin bean cards with tasting notes, and a roastery visit page with subscription strip. Kraft + cream + copper palette.',
    sections: ['Letterpress Cover Sheet with Issue Number', 'Three-Column Printed Menu', 'Probat Roaster Photo with Caption', 'Daily Menu (Espresso · Pour-over · Bakery)', 'Four Single-origin Lot Cards with Notes', 'Roastery Visit Page with Subscription'],
    tech: ['React', 'Framer Motion', 'Tailwind CSS', 'Multi-page'],
    color: '#B87333',
    thumb: '/screenshots/coffee.jpg',
  },
  {
    id: 'cars',
    name: 'Atlas Motors',
    industry: 'Collector Motorhouse',
    price: '$900',
    tier: 'premium',
    status: 'live',
    description: 'Atlas Motors is a four-page Knightsbridge collector motorhouse (Showroom / Catalogue / Workshop / Private viewing). Spring-Catalogue title-page hero with stamped Lot 0114 cover plate (NOT a parallax car hero), pseudo-concours signal-orange marquee strip, six-lot catalogue grid, full lot-by-lot ledger with comp data & provenance, three-track in-house workshop spec, and a private-viewing form. Graphite + signal-orange + chrome palette.',
    sections: ['Catalogue Title-Page Hero with Lot 0114 Plate', 'Concours Marquee Strip', 'Six-Lot Featured Grid', 'Full Lot-by-Lot Catalogue', 'Three-track Workshop Spec', 'Private Viewing Form'],
    tech: ['React', 'Framer Motion', 'Tailwind CSS', 'Multi-page'],
    color: '#FF6B1A',
    thumb: '/screenshots/cars.jpg',
  },
  {
    id: 'education',
    name: 'Lumen Academy',
    industry: 'Cohort-based Academy',
    price: '$850',
    tier: 'premium',
    status: 'live',
    description: 'Lumen Academy is a four-page institutional education folio (Faculty / Spring cohort / Syllabus / Apply). Centered academic masthead hero with rotated-diamond crest and Spring 2026 stamp (NOT a notification-card split hero), three-track cohort programme grid (Engineering / Identity / Founder), large institutional KPI strip, full 12-week syllabus table with weekly readings & deliverables, and a four-question application form. Academic-navy + cream + signal-yellow palette.',
    sections: ['Centered Masthead Hero with Crest', 'Three-track Cohort Grid', 'Institutional KPI Strip', 'Spring Cohort Programme Detail', 'Full 12-week Syllabus Table', 'Four-question Application Form'],
    tech: ['React', 'Framer Motion', 'Tailwind CSS', 'Multi-page'],
    color: '#14213D',
    thumb: '/screenshots/education.jpg',
  },
  {
    id: 'construction',
    name: 'Ironworks GC',
    industry: 'General Contractor',
    price: '$850',
    tier: 'premium',
    status: 'live',
    description: 'Ironworks GC is a four-page tri-state general-contractor jobsite ledger (Yard / Jobs ledger / Safety binder / Bid request). Stamped jobsite-ticket hero with Active job card tilted & safety-orange marquee strip (NOT a yellow industrial cinematic hero, intentionally distinct from Hadid & Vance Architecture), four-job ledger with values & durations, full safety-binder with EMR 0.62 KPIs and eight protocols, five-phase punch-list strip, and a 24-hour bid-request form. Graphite + concrete + safety-orange palette.',
    sections: ['Jobsite-Ticket Hero with Tilted Job Card', 'Safety-Orange Marquee Strip', 'Four-Job Ledger', 'Four-KPI Safety Strip (EMR 0.62)', 'Eight Safety Protocols', 'Five-Phase Punch-List', '24-hr Bid Request Form'],
    tech: ['React', 'Framer Motion', 'Tailwind CSS', 'Multi-page'],
    color: '#FF7A1A',
    thumb: '/screenshots/construction.jpg',
  },
  {
    id: 'yacht',
    name: 'Avalon',
    industry: 'Private Yacht Charter',
    price: '$1,000',
    status: 'live',
    tier: 'signature',
    description: 'Avalon is a four-page Maison-style charter bureau (Home / Fleet / Voyage / Charter) for an Antibes private-yacht house. Cinematic seascape hero, horizontal-scroll fleet panels, vertical spec sheets per yacht (sailing / motor / explorer), a seven-day sample voyage as a horizontal storyboard, and a two-pane charter inquiry form with footnoted fields. Deep navy & brass palette.',
    sections: ['Cinematic Hero with Live Coordinates', 'Horizontal Fleet Carousel', 'Spec Sheets · Three Hulls', 'Crew Strip', 'Sample Voyage Storyboard', 'Charter Inquiry · Footnoted Form'],
    tech: ['React', 'Framer Motion', 'Tailwind CSS', 'Parallax', 'Responsive'],
    color: '#C9A96E',
    thumb: '/screenshots/yacht.jpg',
  },
  {
    id: 'jet',
    name: 'Stratos',
    industry: 'Private Aviation / Jet Charter',
    price: '$1,000',
    status: 'live',
    tier: 'signature',
    description: 'Stratos is a four-page Part-135 jet operator dashboard (Operations / Fleet / Safety File / Quote Terminal). Live UTC clock, departure-board hero with status pings, ID-card spec sheets per aircraft (Light / Mid / Heavy) with hourly rates & range envelope chart, audit-dossier safety file, and a boarding-pass-style quote terminal with live subtotal. Onyx + signal-red palette.',
    sections: ['Live Departure Board Hero', 'KPI Strip · Audit Metrics', 'Quotation Procedure Strip', 'ID-card Aircraft Specs', 'Range Envelope Chart', 'Audit Dossier Pillars', 'Boarding-pass Quote Terminal'],
    tech: ['React', 'Framer Motion', 'Tailwind CSS', 'Parallax', 'Responsive'],
    color: '#A89060',
    thumb: '/screenshots/jet.jpg',
  },
  {
    id: 'artgallery',
    name: 'Halcyon & Vale',
    industry: 'Fine Art Gallery / Auction',
    price: '$1,000',
    status: 'live',
    tier: 'signature',
    description: 'Halcyon & Vale is a four-page bi-national fine-art gallery (Programme / Lot Index / Editorial / Visit). Museum-wall layout with massive whitespace, broadsheet "Programme" calendar, expandable lot-index rows with full provenance tables, gallery essay with drop-cap typography, and two large salon "wall plates" with appointment form. Warm white & tate-red palette.',
    sections: ['Museum Wall Hero · Single Featured Painting', 'Programme Calendar Table', 'Three Featured Lots · Sticky Sidebar', 'Expandable Lot Index Rows', 'Long-form Gallery Essay', 'Two Salon Wall Plates', 'Appointment Form'],
    tech: ['React', 'Framer Motion', 'Tailwind CSS', 'Responsive'],
    color: '#1A1A1A',
    thumb: '/screenshots/artgallery.jpg',
  },
  {
    id: 'privatebank',
    name: 'Westmoreland',
    industry: 'Private Bank / Wealth Management',
    price: '$1,000',
    status: 'live',
    tier: 'signature',
    description: 'Westmoreland is a four-page private-bank broadsheet (Front Page / Practice / House View / Introduction). Newspaper masthead, three-column dropcap front page, market-data ribbon with audit-numbered stats, partnership ledger of 46 partners, full broadsheet research articles with drop-caps and pull-quotes, and a discreet letter-of-introduction form. Cream paper & navy ink.',
    sections: ['Broadsheet Masthead', 'Three-Column Dropcap Lede', 'Market-data Ribbon', 'Partnership Ledger Table', 'Broadsheet Research Article', 'Recent Dispatches Archive', 'Letter of Introduction'],
    tech: ['React', 'Framer Motion', 'Tailwind CSS', 'Layout Animations', 'Responsive'],
    color: '#B8975B',
    thumb: '/screenshots/privatebank.jpg',
  },
  {
    id: 'watch',
    name: 'Vermillion',
    industry: 'Luxury Watch Boutique',
    price: '$1,000',
    status: 'live',
    tier: 'signature',
    description: 'Vermillion is a five-page boutique-horology site (Home / Collection / Service / Journal / Visit) for a Geneva–London–Singapore Patek-authorized house. Editorial type-driven design — no parallax hero, no marquees — with a filterable archive of vintage Pateks, Rolex Daytonas and independents, a long-form atelier essay with a formal service tariff, a magazine-grade journal, and a three-salon visit page with hours tables and private appointment form.',
    sections: ['Home — Editorial Type Hero & Piece of the Week', 'Collection — Filterable 12-piece Archive with Detail Modal', 'Service & Restoration — Long-form Essay + Tariff', 'Journal — Featured Essay + Archive Index', 'Visit — Three Salon Cards + Appointment Form', 'Sticky Multi-page Nav with Reference Search'],
    tech: ['React', 'Framer Motion', 'Tailwind CSS', 'Responsive'],
    color: '#C8A961',
    thumb: '/screenshots/watch.jpg',
  },
  {
    id: 'jewelry',
    name: 'Lumen & Stone',
    industry: 'Bespoke Diamond Atelier',
    price: '$1,000',
    status: 'live',
    tier: 'signature',
    description: 'Lumen & Stone is a four-page Antwerp diamond atelier (Maison / Specimens / Six Months / Commission). Pitch-black velvet bg with champagne accents, single-specimen hero on a plinth, full-bleed "jewel-on-velvet" macro band, museum-pinned 6-piece specimen grid with detail modal, six-month commission timeline with alternating left/right thread, and a quiet commission inquiry form. Velvet near-black & champagne palette.',
    sections: ['Velvet Hero · Single Specimen on a Plinth', 'Champagne Pull-quote Band', 'Jewel-on-velvet Macro Band', 'Museum-pinned Specimen Grid', 'Detail Modal with Spec Table', 'Six-month Commission Timeline', 'Commission Inquiry'],
    tech: ['React', 'Framer Motion', 'Tailwind CSS', 'Responsive'],
    color: '#A8854B',
    thumb: '/screenshots/jewelry.jpg',
  },
  {
    id: 'architecture',
    name: 'Hadid & Vance',
    industry: 'Architecture / Interior Design',
    price: '$1,000',
    status: 'live',
    tier: 'signature',
    description: 'Hadid & Vance is a four-page architecture studio (Studio / Projects / About / Commission) on a strict 12-column blueprint grid. Concrete-grey palette with blueprint-blue ink and signal-yellow callouts. Measurement strip across the top, in-progress project ticker, full-bleed featured project, recognition ledger, filterable project archive (residential/civic/hospitality/workplace), long-form studio essay, and a drawing-spec commission form.',
    sections: ['Top Measurement Strip', 'Blueprint 12-col Hero', 'In-progress Project Ticker', 'Featured Project Full-bleed', 'Stats Row', 'Recognition Ledger', 'Filterable Project Archive', 'Drawing-spec Commission Form'],
    tech: ['React', 'Framer Motion', 'Tailwind CSS', 'Masonry', 'Parallax', 'Responsive'],
    color: '#1A1A1A',
    thumb: '/screenshots/architecture.jpg',
  },
  {
    id: 'filmstudio',
    name: 'Pelagic',
    industry: 'Film / Production Studio',
    price: '$1,000',
    status: 'live',
    tier: 'signature',
    description: 'Pelagic is a four-page film production studio (Reel / Work / Crew / Brief). Cinema black & gold. Letterbox-bar hero with cinemascope ratio & director marks, contact-sheet film index, full-bleed alternating reel theatre with festival credits, credits-roll crew page with frequent-collaborator table, and a clapper-board brief submission form.',
    sections: ['Letterbox-bar Cinemascope Hero', 'Contact-sheet Film Index (6 films)', 'Filterable Reel Theatre', 'Credits-roll Crew Page', 'Frequent Collaborators Table', 'Clapper-board Brief Form'],
    tech: ['React', 'Framer Motion', 'Tailwind CSS', 'Responsive'],
    color: '#D4B16A',
    thumb: '/screenshots/filmstudio.jpg',
  },
  {
    id: 'skincare',
    name: 'Solène',
    industry: 'Luxury Skincare House',
    price: '$1,000',
    status: 'live',
    tier: 'signature',
    description: 'Solène is a four-page Provençal skincare maison (Maison / Le Rituel / L’Atelier / Visit). Soft linen + sage botanical magazine layout. Editorial spread hero, three-step ritual columns (Cleanse / Treat / Restore) with formula cards, long-form atelier essay with founder portrait, refillable-jar product detail spreads, atelier chronology, and a quiet two-letter-a-year newsletter form.',
    sections: ['Botanical Magazine Hero', 'Three-step Ritual Columns', 'Editorial Letters', 'Full-spread Product Pages with Formula Cards', 'Long-form Atelier Essay', 'Atelier Chronology', 'Two Salons + Newsletter'],
    tech: ['React', 'Framer Motion', 'Tailwind CSS', 'Parallax', 'Responsive'],
    color: '#7A6855',
    thumb: '/screenshots/skincare.jpg',
  },
  {
    id: 'tailor',
    name: 'Ashford & Vail',
    industry: 'Bespoke Tailor / Savile Row',
    price: '$1,000',
    status: 'live',
    tier: 'signature',
    description: 'Ashford & Vail is a four-page Savile Row bespoke tailor (House / Lookbook / Six Fittings / Appointment). Pattern-paper cream bg with subtle grid overlay, deep-red wax-seal accents. Type-driven house-notice hero with garment portrait + wax seal, cloth-ledger of 64 bunches, gatefold lookbook spreads (Suiting / Tuxedo / Casual), six-fitting Roman-numeral chapter pages, and a paper-form appointment with cutter selection.',
    sections: ['Pattern-paper Type Hero with Wax Seal', 'Cloth-makers Ledger (64 bunches)', 'Pull-quote', 'Gatefold Lookbook Spreads', 'Six Roman-numeral Fitting Chapters', 'Paper-form Appointment Booking'],
    tech: ['React', 'Framer Motion', 'Tailwind CSS', 'Responsive'],
    color: '#8B6F47',
    thumb: '/screenshots/tailor.jpg',
  },
];
;
